import { useContext } from 'react';

import { MenuDrawerContext } from '../contexts/MenuDrawerContext';

// ----------------------------------------------------------------------

const useMenuDrawer = () => useContext(MenuDrawerContext);

export default useMenuDrawer;
